
/* @ngInject */
function SearchFilters4Controller($scope, $attrs, $stateParams, $location, $timeout, $anchorScroll, $window, $rootScope, raSpinnerService, productLookupService, productFilterService) {
    const vm = this;

    vm.currentFilter = $scope.currentFilter;
    vm.currentFilterTypeId = vm.currentFilter.TypeId;
    vm.descriptiveInput = vm.currentFilter.userInput;
    vm.dirty = false;


    // run on init
    function init() {
        updateFilterFromURL();

        if ($scope.last) {
            $rootScope.$broadcast('searchFiltersDirective.filtersLoaded');
        }
    }
    init();

    function updateFilterFromURL() {
        const currentFilter = vm.currentFilter;
        const values = $scope.getFilterURLValues(currentFilter)[0].values;

        const descriptiveInputText = values[0];

        // set service dto
        const filterForDescriptiveInput = productFilterService.getFilterByAttributeNameId(productFilterService.productTypeFilters, currentFilter.Deprecated_ProductAttributeNameId);
        if (filterForDescriptiveInput) {
            filterForDescriptiveInput.userInput = descriptiveInputText;
            vm.descriptiveInput = descriptiveInputText;

            if (typeof descriptiveInputText !== 'undefined' && descriptiveInputText !== null && descriptiveInputText.length > 0) {
                vm.dirty = true;
            }
        }
    }

    // vm.descriptiveInputChanged = function() {
    //     //$rootScope.$broadcast('searchFiltersDirective.descriptive-input-changed');
    //     if(vm.descriptiveInput.length >= 3) {
    //     	vm.currentFilter.userInput = vm.descriptiveInput;
    //     	$scope.processFilter();
    //     } else if (vm.currentFilter.userInput !== vm.descriptiveInput && vm.descriptiveInput.length === 0) {
    //     	vm.currentFilter.userInput = vm.descriptiveInput;
    //     	$scope.processFilter();
    //     }
    // };

    vm.descriptiveInputSubmit = function () {
        vm.currentFilter.userInput = vm.descriptiveInput;
        $scope.processFilter();
        vm.dirty = true;
    };
}


export default function SearchFilters4Directive() {
    return {
        restrict: 'E',
        templateUrl: 'app/productCenter/pages/productsearch/searchFilters/templates/descriptive-input.html',
        controller: SearchFilters4Controller,
        controllerAs: 'searchFilter',
    };
}




// WEBPACK FOOTER //
// ./src/app/productCenter/pages/productsearch/searchFilters/directives/searchFilterDescriptiveInput.directive.js